const T = {
  de: {
    // ── Months ──────────────────────────────────────────────────────
    months: ['Aug','Sep','Okt','Nov','Dez','Jan','Feb','Mär','Apr','Mai','Jun','Jul'],

    // ── Common ──────────────────────────────────────────────────────
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    close: 'Schließen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    add: 'Hinzufügen',
    search: 'Suchen…',
    export: 'Export',
    loading: 'Laden…',
    error: 'Fehler',
    yes: 'Ja',
    no: 'Nein',
    all: 'Alle',
    none: '—',
    required: 'Pflichtfeld',
    requiredStar: '★ = Pflichtfeld',
    noEntries: 'Keine Einträge',
    noResults: 'Keine Ergebnisse gefunden',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    status: 'Status',
    season: 'Saison',
    note: 'Notiz',
    print: 'Drucken',
    preview: 'Vorschau',
    confirm: 'Bestätigen',
    profile: 'Profil',
    logout: 'Abmelden',
    backup: 'Backup herunterladen',

    // ── Relations ───────────────────────────────────────────────────
    relations: ['Vater','Mutter','Großvater','Großmutter','Vormund','Onkel','Tante','Geschwister','Sonstige'],
    relation_Vater: 'Vater',
    relation_Mutter: 'Mutter',

    // ── Roles ───────────────────────────────────────────────────────
    role_admin: 'Admin',
    role_director: 'Direktor',
    role_teacher: 'Lehrer',
    role_accountant: 'Buchhalter',
    role_office: 'Büro',
    role_parent: 'Elternteil',

    // ── Sidebar ─────────────────────────────────────────────────────
    nav_general: 'Allgemein',
    nav_students: 'Schüler',
    nav_finance: 'Finanzen',
    nav_reports: 'Berichte',
    nav_system: 'System',
    nav_dashboard: 'Dashboard',
    nav_waiting: 'Warteliste',
    nav_activeStudents: 'Aktive Schüler',
    nav_attendance: 'Anwesenheit',
    att_title: 'Anwesenheit',
    att_group: 'Gruppe',
    att_class: 'Klasse',
    att_date: 'Datum',
    att_present: 'Anwesend',
    att_absent: 'Abwesend',
    att_allPresent: 'Alle anwesend',
    att_save: 'Speichern',
    att_noStudents: 'Keine aktiven Schüler in dieser Klasse.',
    att_selectClass: 'Bitte Gruppe und Klasse wählen.',
    att_saved: 'Anwesenheit gespeichert',
    att_month: 'Monat',
    att_overview: 'Übersicht',
    att_sessions: 'Termine',
    att_rate: 'Anwesenheitsquote',
    att_markDayPresent: 'Ganzen Tag als anwesend markieren',
    att_clearDay: 'Tag leeren',
    nav_families: 'Familien',
    nav_payments: 'Zahlungen',
    nav_but: 'BuT',
    nav_customizing: 'Anpassung',
    nav_users: 'Benutzerverwaltung',
    nav_import: 'Daten importieren',
    nav_antraege: 'Anträge',
    nav_jrs: 'Jahresrundschreiben',
    jrs_title: 'Jahresrundschreiben — Daten aktualisieren',
    jrs_info: 'Kopieren Sie die E-Mail-Adressen und informieren Sie die Eltern. Wenn Eltern sich einloggen, sehen sie eine Aufforderung zur Bestätigung.',
    jrs_emails: 'E-Mail-Adressen aller Eltern',
    jrs_status: 'Antwort-Status',
    jrs_confirmed: 'bestätigt',
    jrs_refresh: 'Aktualisieren',
    jrs_new: 'Neues Rundschreiben starten',
    jrs_newConfirm: 'Neues Jahresrundschreiben starten? Alle bisherigen Bestätigungen werden zurückgesetzt.',
    jrs_started: 'Jahresrundschreiben gestartet',
    jrs_badgeConfirmed: 'Bestätigt',
    jrs_badgePending: 'Ausstehend',
    jrs_family: 'Familie',
    jrs_parent: 'Elternteil',
    jrs_email: 'E-Mail',
    jrs_date: 'Datum',

    // ── Dashboard ───────────────────────────────────────────────────
    dashboard_title: 'Dashboard',
    dashboard_welcome: 'Willkommen zurück',
    dashboard_activeStudents: 'Aktive Schüler',
    dashboard_waiting: 'Warteliste',
    dashboard_inactive: 'Inaktiv / Ausgetreten',
    dashboard_totalPaid: 'Gesamt gezahlt',
    dashboard_waitingFor: 'Warten auf Aktivierung',
    dashboard_byGroup: 'Schüler nach Gruppe',
    dashboard_waitingList5: 'Warteliste (letzte 5)',
    dashboard_noEntries: 'Keine Einträge',
    dashboard_boys: 'Jungen',
    dashboard_girls: 'Mädchen',
    dashboard_butAlert: 'BuT-Einträge laufen in den nächsten 30 Tagen ab',
    dashboard_waitAlert: 'Schüler auf der Warteliste warten auf Aktivierung',
    dashboard_seasonLabel: 'Saison',

    // ── Students ────────────────────────────────────────────────────
    students_title: 'Aktive Schüler',
    students_add: 'Schüler hinzufügen',
    students_edit: 'Schüler bearbeiten',
    students_delete: 'Schüler löschen',
    students_deleteConfirm: 'und alle zugehörigen Daten (Zahlungen, Kurswechsel, BuT-Verknüpfungen) unwiderruflich löschen?',
    students_jahreswechsel: 'Jahreswechsel',
    students_kurswechsel: 'Kurswechsel',
    students_deactivate: 'Austritt',
    students_reactivate: 'Reaktivieren',
    students_payment: 'Zahlung',
    students_noFound: 'Keine Schüler gefunden',
    students_count: 'Schüler',
    students_allGroups: 'Alle Gruppen',
    students_filterActive: 'Aktiv',
    students_filterInactive: 'Inaktiv',
    students_filterAll: 'Alle',
    students_allSeasons: 'Alle Saisonen',
    students_nr: 'Nr.',
    students_name: 'Name',
    students_dob: 'Geburt',
    students_group: 'Gruppe',
    students_class: 'Klasse',
    students_parent: 'Erziehungsber.1',
    students_parent2: 'Erziehungsber.2',
    students_saison: 'Saison',
    students_profileTitle: 'Profil',
    students_tabProfile: 'Profil',
    students_tabZahlung: 'Zahlung',
    students_tabVerlauf: 'Verlauf',
    students_tabSiblings: 'Geschwister',
    students_dataSection: 'Schülerdaten',
    students_dob_full: 'Geburtsdatum',
    students_gender: 'Geschlecht',
    students_male: 'Junge (M)',
    students_female: 'Mädchen (W)',
    students_groupClass: 'Gruppe / Klasse',
    students_slot: 'Kurszeit',
    students_startDate: 'Schuleintrittsdatum',
    students_regDate: 'Registrierungsdatum',
    students_endDate: 'Schulverlassensdatum',
    students_completionDate: 'Erfolgreich abgeschlossenes Datum',
    students_exitDate: 'Schulverlassensdatum',
    students_seasons: 'Saison(en)',
    students_family: 'Familie',
    students_notes: 'Notizen',
    students_parentSection: 'Elterninformationen',
    students_guardian: 'Erziehungsber.',
    students_mobile: 'Mobilnr.',
    students_phone: 'Telefon',
    students_email: 'E-Mail',
    students_address: 'Adresse',
    students_datenschutz_ok: 'Datenschutz zugestimmt',
    students_datenschutz_on: 'am',
    students_datenschutz_missing: 'Datenschutzerklärung ausstehend',
    students_kurswechselHistory: 'Kurswechsel-Verlauf',
    students_noKurswechsel: 'Kein Kurswechsel-Verlauf vorhanden',
    students_siblings_count: 'Geschwister verknüpft',
    students_siblings_link: 'Geschwister verknüpfen',
    students_siblings_none: 'Keine Geschwister verknüpft',
    students_siblings_select: 'Schüler auswählen',
    students_siblings_already: '✓ = bereits verknüpft',
    students_siblings_unlink: 'Trennen',
    students_exitModal_title: 'Schüler austragen',
    students_exitDate_label: 'Austrittsdatum',
    students_exitReason: 'Grund',
    students_exitSave: 'Austritt speichern',
    students_exitOptional: 'Optional',
    students_schuleBeenden: 'Schule beenden',
    students_schuleBeenden_title: 'Schule beenden — erfolgreich abgeschlossen',
    students_schuleBeenden_info: 'Diese Schüler werden als inaktiv markiert. Das Erfolgreich abgeschlossenes Datum wird gesetzt. Schulverlassensdatum bleibt leer.',
    students_schuleBeenden_date: 'Erfolgreich abgeschlossenes Datum',
    students_schuleBeenden_reason: 'Bemerkung',
    students_schuleBeenden_save: 'Schule beenden',
    students_schuleBeenden_confirm: 'Schule beenden für',
    kurswechsel_title: 'Kurswechsel',
    kurswechsel_current: 'Aktuell',
    kurswechsel_date: 'Wechsel-Datum',
    kurswechsel_newGroup: 'Neue Gruppe',
    kurswechsel_newClass: 'Neue Klasse',
    kurswechsel_newSlot: 'Neue Kurszeit',
    kurswechsel_fee: 'Neuer Monatsbeitrag (€)',
    kurswechsel_reason: 'Grund (optional)',
    kurswechsel_reasonPlaceholder: 'z.B. Zeitplan geändert',
    kurswechsel_save: 'Wechsel speichern',
    kurswechsel_required: 'Datum, Gruppe und Klasse sind Pflichtfelder',
    kurswechsel_thDate: 'Datum',
    kurswechsel_thFrom: 'Von Gruppe',
    kurswechsel_thFromClass: 'Von Klasse',
    kurswechsel_thTo: 'Nach Gruppe',
    kurswechsel_thToClass: 'Nach Klasse',
    kurswechsel_thSlot: 'Kurszeit',
    kurswechsel_thReason: 'Grund',
    jahreswechsel_title: 'Jahreswechsel — Klassenübergang',
    jahreswechsel_info: 'Alle Schüler einer Klasse werden in eine neue Klasse versetzt. Der Wechsel wird im Kurswechsel-Verlauf festgehalten.',
    jahreswechsel_from: 'Quell-Klasse (Von)',
    jahreswechsel_to: 'Ziel-Klasse (Nach)',
    jahreswechsel_date: 'Wechsel-Datum',
    jahreswechsel_note: 'Hinweis (optional)',
    jahreswechsel_notePlaceholder: 'z.B. Jahreswechsel 2025/2026',
    jahreswechsel_save: 'Klassenübergang durchführen',
    jahreswechsel_saving: 'Wird versetzt…',
    jahreswechsel_required: 'Pflichtfelder ausfüllen',
    jahreswechsel_same: 'Quell- und Zielklasse müssen verschieden sein',
    jahreswechsel_confirm: 'Alle aktiven Schüler aus "{from}" nach "{to}" versetzen?',
    jahreswechsel_success: 'Schüler versetzt',
    students_linkModal_title: 'Geschwister verknüpfen',
    students_linkModal_of: 'Geschwister von',

    // ── Waiting ─────────────────────────────────────────────────────
    waiting_title: 'Warteliste',
    waiting_add: 'Wartelisteneintrag hinzufügen',
    waiting_edit: 'Wartelisteneintrag bearbeiten',
    waiting_activate: 'Aktivieren',
    waiting_noFound: 'Keine Einträge',
    waiting_count: 'Einträge',
    waiting_nr: 'Nr.',
    waiting_regDate: 'Anmeldedatum',
    waiting_name: 'Name',
    waiting_dob: 'Geburt',
    waiting_slot: 'Kurszeit',
    waiting_parent: 'Erziehungsber.',
    waiting_phone: 'Telefon',
    waiting_filterSlot: 'Alle Kurszeiten',

    // ── Families ────────────────────────────────────────────────────
    families_title: 'Familien',
    families_add: 'Familie anlegen',
    families_edit: 'Familie bearbeiten',
    families_count: 'Familien',
    families_nr: 'Nr.',
    families_name: 'Familienname',
    families_parent: 'Erziehungsber.',
    families_contact: 'Kontakt',
    families_children: 'Kinder',
    families_member: 'Mitglied',
    families_noFound: 'Keine Familien gefunden',
    families_deleteConfirm: 'Familie und alle Verknüpfungen löschen?',
    families_linkFamily: 'Bestehende Familie verknüpfen',
    families_newFamily: '— Neue Familie / Keine Verknüpfung —',
    families_autofilled: 'Felder wurden automatisch ausgefüllt.',
    families_siblings: 'Geschwister',
    families_noSiblings: 'Keine weiteren Kinder in dieser Familie.',
    families_parent2: '2. Erziehungsberechtigter (optional)',
    families_parentFirst: 'Vorname Erziehungsber.',
    families_parentLast: 'Nachname Erziehungsber.',
    families_parent2First: 'Vorname 2. Erziehungsber.',
    families_parent2Last: 'Nachname 2. Erziehungsber.',
    families_parent2Rel: 'Verhältnis 2. Erziehungsber.',
    families_parent2Mobile: 'Mobilnr. 2. Erziehungsber.',
    families_parent2Email: 'E-Mail 2. Erziehungsber.',

    // ── Payments ────────────────────────────────────────────────────
    payments_title: 'Zahlungsübersicht',
    payments_rollover: 'Saisonübergang',
    payments_rolloverSelected: 'ausgewählt',
    payments_totalPaid: 'Gesamt gezahlt',
    payments_openMonth: 'Offen (heute)',
    payments_openYear: 'Offen (gesamtes Jahr)',
    payments_filterOverdue: 'Rückstände',
    payments_filterPaid: 'Beglichen',
    payments_nr: 'Nr.',
    payments_name: 'Name',
    payments_group: 'Gr.',
    payments_reg: 'Reg.',
    payments_paid: 'Gez.',
    payments_open: 'Offen (heute)',
    payments_openYearCol: 'Offen (Jahr)',
    payments_carried: 'Übertr.',
    payments_payMode: '⏱',
    payments_yearly: 'Jährlich',
    payments_monthly: 'Monatlich',
    payments_rolloverTitle: 'Saisonübergang',
    payments_rolloverInfo: 'Wählen Sie für jeden Schüler, ob ausstehende Beträge in die neue Saison übertragen werden sollen.',
    payments_fromSeason: 'Von Saison',
    payments_toSeason: 'Nach Saison',
    payments_previewBtn: 'Vorschau laden',
    payments_openAmount: 'Offener Betrag (heute)',
    payments_transfer: 'Übertragen? (€)',
    payments_totalCarry: 'Gesamt Übertrag',
    payments_confirmRollover: 'Übertrag bestätigen',
    payments_doingRollover: 'Wird durchgeführt…',
    payments_rolloverDone: 'Saisonübergang nach "{season}" durchgeführt',
    payments_noTargetSeason: '— keine weiteren Saisons —',
    payments_selectSeason: 'Bitte eine Ziel-Saison auswählen',
    payments_editTitle: 'Zahlung bearbeiten',
    payments_monthlyPay: 'Monatliche Zahlungen',
    payments_paySettings: 'Zahlungseinstellungen',
    payments_payModeLabel: 'Zahlungsweise',
    payments_monthlyFee: 'Monatl. Gebühr (€)',
    payments_monthlyBase: 'Monatl. Basis (€)',
    payments_yearlyDisc: 'Jahresrabatt (€)',
    payments_regFee: 'Anmeldegebühr (€)',
    payments_regFeePaid: 'Anmeldegebühr bezahlt',
    payments_regFeePaidYes: 'Bezahlt',
    payments_regFeePaidNo: 'Nicht bezahlt',
    payments_annualDisc: 'Jahresrabatt (€)',
    payments_waiver: 'Erlass (€)',
    payments_waiverReason: 'Erlassgrund',
    payments_carriedField: 'Übertrag (€)',
    payments_butRef: 'BuT Referenz',
    payments_noteLabel: 'Notiz',
    payments_notePlaceholder: 'Zahlungsnotiz…',
    payments_expected: 'Erwartet',
    payments_paidLabel: 'Bezahlt',
    payments_openLabel: 'Offen (heute)',
    payments_monthly: 'Monatl.',
    payments_carriedLabel: 'Übertrag',
    payments_carriedFrom: 'aus',
    payments_carriedPrev: 'aus Vorjahr',
    payments_carriedNote: 'bereits in „Offen (heute)" eingerechnet',
    payments_stand: 'Stand',
    payments_editInTable: 'Einzelne Monate direkt in der Tabelle bearbeiten',
    payments_regFeeStatus: 'Anmeldegebühr bezahlt',
    payments_selectGroup: '— Gruppe wählen —',
    payments_selectClass: '— Klasse wählen —',
    payments_selectSlot: '— Kurszeit wählen —',

    // ── Reports ─────────────────────────────────────────────────────
    reports_title: 'Berichte',
    reports_tabStats: '📊 Statistik',
    reports_tabBal: 'Ausstände',
    reports_tabMonthly: 'Monatseinnahmen',
    reports_tabRoster: 'Klassenliste',
    reports_tabBut: 'BuT-Übersicht',
    reports_totalStudents: 'Gesamt Schüler',
    reports_active: 'Aktiv',
    reports_inactive: 'Inaktiv',
    reports_boys: 'Jungen (aktiv)',
    reports_girls: 'Mädchen (aktiv)',
    reports_byGroup: 'Schüler nach Gruppe',
    reports_ageGroups: 'Altersgruppen (aktive Schüler)',
    reports_ageCol: 'Alter',
    reports_boysCol: 'Jungen',
    reports_girlsCol: 'Mädchen',
    reports_totalCol: 'Ges.',
    reports_balNr: 'Nr.',
    reports_balName: 'Name',
    reports_balGroup: 'Gruppe',
    reports_balPaid: 'Gez.',
    reports_balOpen: 'Offen (heute)',
    reports_monthNr: 'Nr.',
    reports_monthName: 'Name',
    reports_monthTotal: 'Gesamt',
    reports_rosterNr: '#',
    reports_rosterName: 'Name',
    reports_rosterDob: 'Geburt',
    reports_rosterGroup: 'Gruppe',
    reports_rosterSlot: 'Kurszeit',
    reports_rosterParent: 'Elternteil',
    reports_rosterPhone: 'Telefon',
    reports_allGroups: 'Alle Gruppen',
    reports_print: '🖨 Drucken',
    reports_noStudents: 'Keine Schüler gefunden',
    reports_butNr: 'Nr.',
    reports_butChild: 'Kind',
    reports_butStudent: 'Schüler',
    reports_butGroup: 'Gruppe',
    reports_butType: 'Art',
    reports_butExpiry: 'Gültig bis',
    reports_butExpired: 'BuT-Einträge sind abgelaufen',
    reports_butExpiring: 'BuT-Einträge laufen in 30 Tagen ab',
    reports_noBut: 'Keine BuT-Einträge',
    reports_balViewStudent: 'Schüler',
    reports_balViewFamily: 'Familie',
    reports_balFamChildren: 'Kinder',
    reports_balFamNoFamily: 'Ohne Familie',

    // ── BuT ─────────────────────────────────────────────────────────
    but_title: 'BuT-Verwaltung',
    but_tabEntries: 'BuT-Einträge',
    but_tabPayments: 'Auszahlungen',
    but_add: 'BuT-Eintrag hinzufügen',
    but_edit: 'BuT-Eintrag bearbeiten',
    but_addPayment: 'Auszahlung erfassen',
    but_deleteConfirm: 'BuT-Eintrag löschen?',
    but_nr: 'Nr.',
    but_child: 'Kind',
    but_student: 'Schüler',
    but_type: 'Art',
    but_validFrom: 'Von',
    but_validTo: 'Bis',
    but_amount: 'Betrag/Monat',
    but_status: 'Status',
    but_noEntries: 'Keine BuT-Einträge',
    but_letter: 'Anschreiben',
    but_expiredAlert: 'BuT-Einträge abgelaufen',
    but_expiringAlert: 'BuT-Einträge laufen in 30 Tagen ab',

    // ── Customizing ─────────────────────────────────────────────────
    customizing_title: 'Anpassung',
    customizing_tabGruppe: 'Gruppen',
    customizing_tabKlasse: 'Klassen',
    customizing_tabSlot: 'Kurszeiten',
    customizing_tabBildungsgrad: 'Bildungsgrad',
    customizing_tabSeasons: 'Saison/Jahr',
    customizing_tabCounters: 'Nummernkreise',
    customizing_addGroup: 'Gruppe hinzufügen',
    customizing_addClass: 'Klasse hinzufügen',
    customizing_addSlot: 'Kurszeit hinzufügen',
    customizing_addSeason: 'Saison anlegen',
    customizing_activateSeason: 'Aktivieren',
    customizing_saveCounters: 'Nummernkreise speichern',
    customizing_seasonCode: 'Code',
    customizing_seasonLabel: 'Bezeichnung',
    customizing_seasonStart: 'Start',
    customizing_seasonEnd: 'Ende',
    customizing_activeSeason: 'Aktiv',
    customizing_group: 'Gruppe',
    customizing_fee: 'Monatsbeitrag (€)',
    customizing_order: 'Reihenfolge',
    customizing_prefix: 'Präfix',
    customizing_nextNr: 'Nächste Nr.',

    // ── Users ───────────────────────────────────────────────────────
    users_title: 'Benutzerverwaltung',
    users_add: 'Benutzer anlegen',
    users_username: 'Benutzername',
    users_fullName: 'Name',
    users_role: 'Rolle',
    users_family: 'Familie',
    users_language: 'Sprache',
    users_status: 'Status',
    users_password: 'Passwort',
    users_changePassword: 'Passwort ändern',
    users_newPassword: 'Neues Passwort',
    users_confirmPassword: 'Passwort bestätigen',
    users_deactivateConfirm: 'Benutzer deaktivieren?',
    users_deactivated: 'Deaktiviert',
    users_created: 'Benutzer angelegt',
    users_pwChanged: 'Passwort geändert',
    users_selectFamily: '— Familie wählen —',
    users_lang_de: 'Deutsch',
    users_lang_tr: 'Türkçe',
    users_lang_en: 'English',
    users_pwMin: 'Passwort mind. 8 Zeichen',
    users_pwMismatch: 'Passwörter stimmen nicht überein',

    // ── Import ──────────────────────────────────────────────────────
    import_title: 'Daten importieren',
    import_noAccess: 'Kein Zugriff',
    import_downloadTemplate: 'Vorlage herunterladen',
    import_uploadFile: 'Datei hochladen',
    import_confirmImport: 'Import bestätigen',
    import_backupTitle: 'Backup / Wiederherstellung',
    import_backupRestore: 'Backup wiederherstellen',

    // ── Login ───────────────────────────────────────────────────────
    login_title: 'Maktab',
    login_sub: 'Schülerverwaltungssystem',
    login_user: 'Benutzername',
    login_pass: 'Passwort',
    login_btn: 'Anmelden',
    login_err: 'Ungültige Anmeldedaten',
    login_welcome: 'Willkommen',
  },

  tr: {
    months: ['Ağu','Eyl','Eki','Kas','Ara','Oca','Şub','Mar','Nis','May','Haz','Tem'],

    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    cancel: 'İptal',
    close: 'Kapat',
    edit: 'Düzenle',
    delete: 'Sil',
    add: 'Ekle',
    search: 'Ara…',
    export: 'Dışa Aktar',
    loading: 'Yükleniyor…',
    error: 'Hata',
    yes: 'Evet',
    no: 'Hayır',
    all: 'Tümü',
    none: '—',
    required: 'Zorunlu alan',
    requiredStar: '★ = Zorunlu alan',
    noEntries: 'Kayıt yok',
    noResults: 'Sonuç bulunamadı',
    active: 'Aktif',
    inactive: 'Pasif',
    status: 'Durum',
    season: 'Dönem',
    note: 'Not',
    print: 'Yazdır',
    preview: 'Önizleme',
    confirm: 'Onayla',
    profile: 'Profil',
    logout: 'Çıkış Yap',
    backup: 'Yedek İndir',

    relations: ['Baba','Anne','Büyükbaba','Büyükanne','Vasi','Amca/Dayı','Teyze/Hala','Kardeş','Diğer'],
    relation_Vater: 'Baba',
    relation_Mutter: 'Anne',

    role_admin: 'Yönetici',
    role_director: 'Müdür',
    role_teacher: 'Öğretmen',
    role_accountant: 'Muhasebeci',
    role_office: 'Ofis',
    role_parent: 'Veli',

    nav_general: 'Genel',
    nav_students: 'Öğrenciler',
    nav_finance: 'Finans',
    nav_reports: 'Raporlar',
    nav_system: 'Sistem',
    nav_dashboard: 'Kontrol Paneli',
    nav_waiting: 'Bekleme Listesi',
    nav_activeStudents: 'Aktif Öğrenciler',
    nav_attendance: 'Yoklama',
    att_title: 'Yoklama',
    att_group: 'Grup',
    att_class: 'Sınıf',
    att_date: 'Tarih',
    att_present: 'Var',
    att_absent: 'Yok',
    att_allPresent: 'Hepsi var',
    att_save: 'Kaydet',
    att_noStudents: 'Bu sınıfta aktif öğrenci yok.',
    att_selectClass: 'Lütfen grup ve sınıf seçin.',
    att_saved: 'Yoklama kaydedildi',
    att_month: 'Ay',
    att_overview: 'Genel Bakış',
    att_sessions: 'Oturumlar',
    att_rate: 'Devam oranı',
    att_markDayPresent: 'Tüm günü var olarak işaretle',
    att_clearDay: 'Günü temizle',
    nav_families: 'Aileler',
    nav_payments: 'Ödemeler',
    nav_but: 'BuT',
    nav_customizing: 'Özelleştirme',
    nav_users: 'Kullanıcı Yönetimi',
    nav_import: 'Veri İçe Aktar',
    nav_antraege: 'Başvurular',
    nav_jrs: 'Yıllık Bülten',
    jrs_title: 'Yıllık Bülten — Verileri Güncelle',
    jrs_info: 'E-posta adreslerini kopyalayın ve velileri bilgilendirin. Veliler giriş yaptıklarında onay isteği görecekler.',
    jrs_emails: 'Tüm Velilerin E-posta Adresleri',
    jrs_status: 'Yanıt Durumu',
    jrs_confirmed: 'onaylandı',
    jrs_refresh: 'Yenile',
    jrs_new: 'Yeni Bülten Başlat',
    jrs_newConfirm: 'Yeni yıllık bülten başlatılsın mı? Tüm önceki onaylar sıfırlanacak.',
    jrs_started: 'Yıllık bülten başlatıldı',
    jrs_badgeConfirmed: 'Onaylandı',
    jrs_badgePending: 'Beklemede',
    jrs_family: 'Aile',
    jrs_parent: 'Veli',
    jrs_email: 'E-posta',
    jrs_date: 'Tarih',

    dashboard_title: 'Kontrol Paneli',
    dashboard_welcome: 'Tekrar Hoş Geldiniz',
    dashboard_activeStudents: 'Aktif Öğrenciler',
    dashboard_waiting: 'Bekleme Listesi',
    dashboard_inactive: 'Pasif / Ayrılanlar',
    dashboard_totalPaid: 'Toplam Ödenen',
    dashboard_waitingFor: 'Aktivasyon Bekliyor',
    dashboard_byGroup: 'Gruba Göre Öğrenciler',
    dashboard_waitingList5: 'Bekleme Listesi (son 5)',
    dashboard_noEntries: 'Kayıt yok',
    dashboard_boys: 'Erkek',
    dashboard_girls: 'Kız',
    dashboard_butAlert: 'BuT kaydı 30 gün içinde sona eriyor',
    dashboard_waitAlert: 'öğrenci aktivasyon bekliyor',
    dashboard_seasonLabel: 'Sezon',

    students_title: 'Aktif Öğrenciler',
    students_add: 'Öğrenci Ekle',
    students_edit: 'Öğrenciyi Düzenle',
    students_delete: 'Öğrenciyi Sil',
    students_deleteConfirm: 've tüm ilgili veriler (Ödemeler, Sınıf değişiklikleri, BuT bağlantıları) kalıcı olarak silinsin mi?',
    students_jahreswechsel: 'Yıl Geçişi',
    students_kurswechsel: 'Sınıf Değişikliği',
    students_deactivate: 'Ayrılış',
    students_reactivate: 'Yeniden Aktifleştir',
    students_payment: 'Ödeme',
    students_noFound: 'Öğrenci bulunamadı',
    students_count: 'Öğrenci',
    students_allGroups: 'Tüm Gruplar',
    students_filterActive: 'Aktif',
    students_filterInactive: 'Pasif',
    students_filterAll: 'Tümü',
    students_allSeasons: 'Tüm Dönemler',
    students_nr: 'No.',
    students_name: 'Ad Soyad',
    students_dob: 'Doğum',
    students_group: 'Grup',
    students_class: 'Sınıf',
    students_parent: 'Veli 1',
    students_parent2: 'Veli 2',
    students_saison: 'Dönem',
    students_profileTitle: 'Profil',
    students_tabProfile: 'Profil',
    students_tabZahlung: 'Ödeme',
    students_tabVerlauf: 'Geçmiş',
    students_tabSiblings: 'Kardeşler',
    students_dataSection: 'Öğrenci Bilgileri',
    students_dob_full: 'Doğum Tarihi',
    students_gender: 'Cinsiyet',
    students_male: 'Erkek',
    students_female: 'Kız',
    students_groupClass: 'Grup / Sınıf',
    students_slot: 'Ders Saati',
    students_startDate: 'Başlangıç Tarihi',
    students_regDate: 'Kayıt Tarihi',
    students_exitDate: 'Ayrılış Tarihi',
    students_seasons: 'Dönem(ler)',
    students_family: 'Aile',
    students_notes: 'Notlar',
    students_parentSection: 'Veli Bilgileri',
    students_guardian: 'Veli',
    students_mobile: 'Cep Tel.',
    students_phone: 'Telefon',
    students_email: 'E-posta',
    students_address: 'Adres',
    students_datenschutz_ok: 'Gizlilik Sözleşmesi Onaylandı',
    students_datenschutz_on: 'tarihinde',
    students_datenschutz_missing: 'Gizlilik Sözleşmesi Beklemede',
    students_kurswechselHistory: 'Sınıf Değişikliği Geçmişi',
    students_noKurswechsel: 'Sınıf değişikliği geçmişi yok',
    students_siblings_count: 'kardeş bağlı',
    students_siblings_link: 'Kardeş Bağla',
    students_siblings_none: 'Bağlı kardeş yok',
    students_siblings_select: 'Öğrenci seçin',
    students_siblings_already: '✓ = zaten bağlı',
    students_siblings_unlink: 'Bağlantıyı Kes',
    students_exitModal_title: 'Öğrenci Kaydını Kapat',
    students_exitDate_label: 'Ayrılış Tarihi',
    students_exitReason: 'Neden',
    students_exitSave: 'Ayrılışı Kaydet',
    students_exitOptional: 'İsteğe bağlı',
    kurswechsel_title: 'Sınıf Değişikliği',
    kurswechsel_current: 'Mevcut',
    kurswechsel_date: 'Değişim Tarihi',
    kurswechsel_newGroup: 'Yeni Grup',
    kurswechsel_newClass: 'Yeni Sınıf',
    kurswechsel_newSlot: 'Yeni Ders Saati',
    kurswechsel_fee: 'Yeni Aylık Ücret (€)',
    kurswechsel_reason: 'Neden (isteğe bağlı)',
    kurswechsel_reasonPlaceholder: 'örn. Program değişti',
    kurswechsel_save: 'Değişikliği Kaydet',
    kurswechsel_required: 'Tarih, Grup ve Sınıf zorunlu alanlardır',
    kurswechsel_thDate: 'Tarih',
    kurswechsel_thFrom: 'Önceki Grup',
    kurswechsel_thFromClass: 'Önceki Sınıf',
    kurswechsel_thTo: 'Yeni Grup',
    kurswechsel_thToClass: 'Yeni Sınıf',
    kurswechsel_thSlot: 'Ders Saati',
    kurswechsel_thReason: 'Neden',
    jahreswechsel_title: 'Yıl Geçişi — Sınıf Terfi',
    jahreswechsel_info: 'Bir sınıftaki tüm öğrenciler yeni bir sınıfa taşınır. Değişiklik sınıf geçmişine kaydedilir.',
    jahreswechsel_from: 'Kaynak Sınıf (Den)',
    jahreswechsel_to: 'Hedef Sınıf (E)',
    jahreswechsel_date: 'Değişim Tarihi',
    jahreswechsel_note: 'Not (isteğe bağlı)',
    jahreswechsel_notePlaceholder: 'örn. Yıl geçişi 2025/2026',
    jahreswechsel_save: 'Sınıf Geçişini Gerçekleştir',
    jahreswechsel_saving: 'Taşınıyor…',
    jahreswechsel_required: 'Zorunlu alanları doldurun',
    jahreswechsel_same: 'Kaynak ve hedef sınıf farklı olmalıdır',
    jahreswechsel_confirm: '"{from}" sınıfındaki tüm aktif öğrenciler "{to}" sınıfına taşınsın mı?',
    jahreswechsel_success: 'öğrenci taşındı',
    students_linkModal_title: 'Kardeş Bağla',
    students_linkModal_of: 'Kardeşler',

    waiting_title: 'Bekleme Listesi',
    waiting_add: 'Bekleme Listesine Ekle',
    waiting_edit: 'Kaydı Düzenle',
    waiting_activate: 'Aktifleştir',
    waiting_noFound: 'Kayıt yok',
    waiting_count: 'Kayıt',
    waiting_nr: 'No.',
    waiting_regDate: 'Kayıt Tarihi',
    waiting_name: 'Ad Soyad',
    waiting_dob: 'Doğum',
    waiting_slot: 'Ders Saati',
    waiting_parent: 'Veli',
    waiting_phone: 'Telefon',
    waiting_filterSlot: 'Tüm Ders Saatleri',

    families_title: 'Aileler',
    families_add: 'Aile Ekle',
    families_edit: 'Aileyi Düzenle',
    families_count: 'Aile',
    families_nr: 'No.',
    families_name: 'Aile Adı',
    families_parent: 'Veli',
    families_contact: 'İletişim',
    families_children: 'Çocuklar',
    families_member: 'Üye',
    families_noFound: 'Aile bulunamadı',
    families_deleteConfirm: 'Aile ve tüm bağlantılar silinsin mi?',
    families_linkFamily: 'Mevcut Aileyle İlişkilendir',
    families_newFamily: '— Yeni Aile / İlişkilendirme Yok —',
    families_autofilled: 'Alanlar otomatik dolduruldu.',
    families_siblings: 'Kardeşler',
    families_noSiblings: 'Bu ailede başka çocuk yok.',
    families_parent2: '2. Veli (isteğe bağlı)',
    families_parentFirst: 'Veli Adı',
    families_parentLast: 'Veli Soyadı',
    families_parent2First: '2. Veli Adı',
    families_parent2Last: '2. Veli Soyadı',
    families_parent2Rel: '2. Veli Yakınlık',
    families_parent2Mobile: '2. Veli Cep Tel.',
    families_parent2Email: '2. Veli E-posta',

    payments_title: 'Ödeme Özeti',
    payments_rollover: 'Dönem Geçişi',
    payments_rolloverSelected: 'seçili',
    payments_totalPaid: 'Toplam Ödenen',
    payments_openMonth: 'Bekleyen (bu ay)',
    payments_openYear: 'Bekleyen (yıllık)',
    payments_filterOverdue: 'Borçlu',
    payments_filterPaid: 'Ödenmiş',
    payments_nr: 'No.',
    payments_name: 'Ad Soyad',
    payments_group: 'Grp.',
    payments_reg: 'Kay.',
    payments_paid: 'Öd.',
    payments_open: 'Kalan',
    payments_openYearCol: 'Kalan (Yıl)',
    payments_carried: 'Devir',
    payments_payMode: '⏱',
    payments_yearly: 'Yıllık',
    payments_monthly: 'Aylık',
    payments_rolloverTitle: 'Dönem Geçişi',
    payments_rolloverInfo: 'Her öğrenci için bekleyen tutarların yeni döneme aktarılıp aktarılmayacağını seçin.',
    payments_fromSeason: 'Mevcut Dönem',
    payments_toSeason: 'Hedef Dönem',
    payments_previewBtn: 'Önizleme',
    payments_openAmount: 'Bekleyen Tutar',
    payments_transfer: 'Aktarılsın mı? (€)',
    payments_totalCarry: 'Toplam Devir',
    payments_confirmRollover: 'Devri Onayla',
    payments_doingRollover: 'Gerçekleştiriliyor…',
    payments_rolloverDone: '"{season}" dönemine geçiş yapıldı',
    payments_noTargetSeason: '— başka dönem yok —',
    payments_selectSeason: 'Lütfen hedef dönemi seçin',
    payments_editTitle: 'Ödeme Düzenle',
    payments_monthlyPay: 'Aylık Ödemeler',
    payments_paySettings: 'Ödeme Ayarları',
    payments_payModeLabel: 'Ödeme Şekli',
    payments_monthlyFee: 'Aylık Ücret (€)',
    payments_monthlyBase: 'Aylık Baz (€)',
    payments_yearlyDisc: 'Yıllık İndirim (€)',
    payments_regFee: 'Kayıt Ücreti (€)',
    payments_regFeePaid: 'Kayıt Ücreti Ödendi',
    payments_regFeePaidYes: 'Ödendi',
    payments_regFeePaidNo: 'Ödenmedi',
    payments_annualDisc: 'Yıllık İndirim (€)',
    payments_waiver: 'Muafiyet (€)',
    payments_waiverReason: 'Muafiyet Nedeni',
    payments_carriedField: 'Devir (€)',
    payments_butRef: 'BuT Referans',
    payments_noteLabel: 'Not',
    payments_notePlaceholder: 'Ödeme notu…',
    payments_expected: 'Beklenen',
    payments_paidLabel: 'Ödenen',
    payments_openLabel: 'Kalan',
    payments_monthly: 'Aylık',
    payments_carriedLabel: 'Devir',
    payments_carriedFrom: 'kaynaklı',
    payments_carriedPrev: 'önceki dönemden',
    payments_carriedNote: '"Kalan" tutara dahil',
    payments_stand: 'Durum',
    payments_editInTable: 'Aylık ödemeleri tabloda düzenleyin',
    payments_regFeeStatus: 'Kayıt ücreti ödeme durumu',
    payments_selectGroup: '— Grup Seçin —',
    payments_selectClass: '— Sınıf Seçin —',
    payments_selectSlot: '— Ders Saati Seçin —',

    reports_title: 'Raporlar',
    reports_tabStats: '📊 İstatistik',
    reports_tabBal: 'Borçlar',
    reports_tabMonthly: 'Aylık Gelir',
    reports_tabRoster: 'Sınıf Listesi',
    reports_tabBut: 'BuT Özeti',
    reports_totalStudents: 'Toplam Öğrenci',
    reports_active: 'Aktif',
    reports_inactive: 'Pasif',
    reports_boys: 'Erkek (aktif)',
    reports_girls: 'Kız (aktif)',
    reports_byGroup: 'Gruba Göre Öğrenciler',
    reports_ageGroups: 'Yaş Grupları (aktif öğrenciler)',
    reports_ageCol: 'Yaş',
    reports_boysCol: 'Erkek',
    reports_girlsCol: 'Kız',
    reports_totalCol: 'Top.',
    reports_balNr: 'No.',
    reports_balName: 'Ad Soyad',
    reports_balGroup: 'Grup',
    reports_balPaid: 'Öd.',
    reports_balOpen: 'Kalan',
    reports_monthNr: 'No.',
    reports_monthName: 'Ad Soyad',
    reports_monthTotal: 'Toplam',
    reports_rosterNr: '#',
    reports_rosterName: 'Ad Soyad',
    reports_rosterDob: 'Doğum',
    reports_rosterGroup: 'Grup',
    reports_rosterSlot: 'Ders Saati',
    reports_rosterParent: 'Veli',
    reports_rosterPhone: 'Telefon',
    reports_allGroups: 'Tüm Gruplar',
    reports_print: '🖨 Yazdır',
    reports_noStudents: 'Öğrenci bulunamadı',
    reports_butNr: 'No.',
    reports_butChild: 'Çocuk',
    reports_butStudent: 'Öğrenci',
    reports_butGroup: 'Grup',
    reports_butType: 'Tür',
    reports_butExpiry: 'Geçerlilik',
    reports_butExpired: 'BuT kaydı süresi doldu',
    reports_butExpiring: 'BuT kaydı 30 günde sona eriyor',
    reports_noBut: 'BuT kaydı yok',
    reports_balViewStudent: 'Öğrenci',
    reports_balViewFamily: 'Aile',
    reports_balFamChildren: 'Çocuk',
    reports_balFamNoFamily: 'Ailesiz',

    but_title: 'BuT Yönetimi',
    but_tabEntries: 'BuT Kayıtları',
    but_tabPayments: 'Ödemeler',
    but_add: 'BuT Kaydı Ekle',
    but_edit: 'BuT Kaydını Düzenle',
    but_addPayment: 'Ödeme Ekle',
    but_deleteConfirm: 'BuT kaydı silinsin mi?',
    but_nr: 'No.',
    but_child: 'Çocuk',
    but_student: 'Öğrenci',
    but_type: 'Tür',
    but_validFrom: 'Başlangıç',
    but_validTo: 'Bitiş',
    but_amount: 'Tutar/Ay',
    but_status: 'Durum',
    but_noEntries: 'BuT kaydı yok',
    but_letter: 'Mektup',
    but_expiredAlert: 'BuT kaydı süresi doldu',
    but_expiringAlert: 'BuT kaydı 30 günde sona eriyor',

    customizing_title: 'Özelleştirme',
    customizing_tabGruppe: 'Gruplar',
    customizing_tabKlasse: 'Sınıflar',
    customizing_tabSlot: 'Ders Saatleri',
    customizing_tabBildungsgrad: 'Eğitim Seviyesi',
    customizing_tabSeasons: 'Dönem/Yıl',
    customizing_tabCounters: 'Numara Serileri',
    customizing_addGroup: 'Grup Ekle',
    customizing_addClass: 'Sınıf Ekle',
    customizing_addSlot: 'Ders Saati Ekle',
    customizing_addSeason: 'Dönem Ekle',
    customizing_activateSeason: 'Aktifleştir',
    customizing_saveCounters: 'Numara Serilerini Kaydet',
    customizing_seasonCode: 'Kod',
    customizing_seasonLabel: 'Ad',
    customizing_seasonStart: 'Başlangıç',
    customizing_seasonEnd: 'Bitiş',
    customizing_activeSeason: 'Aktif',
    customizing_group: 'Grup',
    customizing_fee: 'Aylık Ücret (€)',
    customizing_order: 'Sıra',
    customizing_prefix: 'Önek',
    customizing_nextNr: 'Sonraki No.',

    users_title: 'Kullanıcı Yönetimi',
    users_add: 'Kullanıcı Ekle',
    users_username: 'Kullanıcı Adı',
    users_fullName: 'Ad Soyad',
    users_role: 'Rol',
    users_family: 'Aile',
    users_language: 'Dil',
    users_status: 'Durum',
    users_password: 'Şifre',
    users_changePassword: 'Şifreyi Değiştir',
    users_newPassword: 'Yeni Şifre',
    users_confirmPassword: 'Şifreyi Onayla',
    users_deactivateConfirm: 'Kullanıcı devre dışı bırakılsın mı?',
    users_deactivated: 'Devre Dışı Bırakıldı',
    users_created: 'Kullanıcı oluşturuldu',
    users_pwChanged: 'Şifre değiştirildi',
    users_selectFamily: '— Aile Seçin —',
    users_lang_de: 'Deutsch',
    users_lang_tr: 'Türkçe',
    users_lang_en: 'English',
    users_pwMin: 'Şifre en az 8 karakter olmalı',
    users_pwMismatch: 'Şifreler eşleşmiyor',

    import_title: 'Veri İçe Aktar',
    import_noAccess: 'Erişim Yok',
    import_downloadTemplate: 'Şablon İndir',
    import_uploadFile: 'Dosya Yükle',
    import_confirmImport: 'İçe Aktarmayı Onayla',
    import_backupTitle: 'Yedekleme / Geri Yükleme',
    import_backupRestore: 'Yedeği Geri Yükle',

    login_title: 'Maktab',
    login_sub: 'Öğrenci Yönetim Sistemi',
    login_user: 'Kullanıcı Adı',
    login_pass: 'Şifre',
    login_btn: 'Giriş Yap',
    login_err: 'Geçersiz kimlik bilgileri',
    login_welcome: 'Hoş Geldiniz',
  },

  en: {
    months: ['Aug','Sep','Oct','Nov','Dec','Jan','Feb','Mar','Apr','May','Jun','Jul'],

    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    close: 'Close',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    search: 'Search…',
    export: 'Export',
    loading: 'Loading…',
    error: 'Error',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    none: '—',
    required: 'Required field',
    requiredStar: '★ = Required field',
    noEntries: 'No entries',
    noResults: 'No results found',
    active: 'Active',
    inactive: 'Inactive',
    status: 'Status',
    season: 'Season',
    note: 'Note',
    print: 'Print',
    preview: 'Preview',
    confirm: 'Confirm',
    profile: 'Profile',
    logout: 'Sign Out',
    backup: 'Download Backup',

    relations: ['Father','Mother','Grandfather','Grandmother','Guardian','Uncle','Aunt','Sibling','Other'],
    relation_Vater: 'Father',
    relation_Mutter: 'Mother',

    role_admin: 'Admin',
    role_director: 'Director',
    role_teacher: 'Teacher',
    role_accountant: 'Accountant',
    role_office: 'Office',
    role_parent: 'Parent',

    nav_general: 'General',
    nav_students: 'Students',
    nav_finance: 'Finance',
    nav_reports: 'Reports',
    nav_system: 'System',
    nav_dashboard: 'Dashboard',
    nav_waiting: 'Waiting List',
    nav_activeStudents: 'Active Students',
    nav_attendance: 'Attendance',
    att_title: 'Attendance',
    att_group: 'Group',
    att_class: 'Class',
    att_date: 'Date',
    att_present: 'Present',
    att_absent: 'Absent',
    att_allPresent: 'All present',
    att_save: 'Save',
    att_noStudents: 'No active students in this class.',
    att_selectClass: 'Please select group and class.',
    att_saved: 'Attendance saved',
    att_month: 'Month',
    att_overview: 'Overview',
    att_sessions: 'Sessions',
    att_rate: 'Attendance rate',
    att_markDayPresent: 'Mark whole day present',
    att_clearDay: 'Clear day',
    nav_families: 'Families',
    nav_payments: 'Payments',
    nav_but: 'BuT',
    nav_customizing: 'Customizing',
    nav_users: 'User Management',
    nav_import: 'Import Data',
    nav_antraege: 'Requests',
    nav_jrs: 'Annual Newsletter',
    jrs_title: 'Annual Newsletter — Update Data',
    jrs_info: 'Copy the email addresses and inform the parents. When parents log in, they will see a confirmation prompt.',
    jrs_emails: 'Email Addresses of All Parents',
    jrs_status: 'Response Status',
    jrs_confirmed: 'confirmed',
    jrs_refresh: 'Refresh',
    jrs_new: 'Start New Newsletter',
    jrs_newConfirm: 'Start new annual newsletter? All previous confirmations will be reset.',
    jrs_started: 'Annual newsletter started',
    jrs_badgeConfirmed: 'Confirmed',
    jrs_badgePending: 'Pending',
    jrs_family: 'Family',
    jrs_parent: 'Parent',
    jrs_email: 'Email',
    jrs_date: 'Date',

    dashboard_title: 'Dashboard',
    dashboard_welcome: 'Welcome back',
    dashboard_activeStudents: 'Active Students',
    dashboard_waiting: 'Waiting List',
    dashboard_inactive: 'Inactive / Left',
    dashboard_totalPaid: 'Total Paid',
    dashboard_waitingFor: 'Waiting for Activation',
    dashboard_byGroup: 'Students by Group',
    dashboard_waitingList5: 'Waiting List (last 5)',
    dashboard_noEntries: 'No entries',
    dashboard_boys: 'Boys',
    dashboard_girls: 'Girls',
    dashboard_butAlert: 'BuT entries expiring within 30 days',
    dashboard_waitAlert: 'students on waiting list pending activation',
    dashboard_seasonLabel: 'Season',

    students_title: 'Active Students',
    students_add: 'Add Student',
    students_edit: 'Edit Student',
    students_delete: 'Delete Student',
    students_deleteConfirm: 'and all related data (payments, course changes, BuT links) will be permanently deleted?',
    students_jahreswechsel: 'Year Transition',
    students_kurswechsel: 'Course Change',
    students_deactivate: 'Deactivate',
    students_reactivate: 'Reactivate',
    students_payment: 'Payment',
    students_noFound: 'No students found',
    students_count: 'Students',
    students_allGroups: 'All Groups',
    students_filterActive: 'Active',
    students_filterInactive: 'Inactive',
    students_filterAll: 'All',
    students_allSeasons: 'All Seasons',
    students_nr: 'No.',
    students_name: 'Name',
    students_dob: 'Birth',
    students_group: 'Group',
    students_class: 'Class',
    students_parent: 'Guardian 1',
    students_parent2: 'Guardian 2',
    students_saison: 'Season',
    students_profileTitle: 'Profile',
    students_tabProfile: 'Profile',
    students_tabZahlung: 'Payment',
    students_tabVerlauf: 'History',
    students_tabSiblings: 'Siblings',
    students_dataSection: 'Student Data',
    students_dob_full: 'Date of Birth',
    students_gender: 'Gender',
    students_male: 'Boy (M)',
    students_female: 'Girl (F)',
    students_groupClass: 'Group / Class',
    students_slot: 'Course Time',
    students_startDate: 'Start Date',
    students_regDate: 'Registration Date',
    students_exitDate: 'Exit Date',
    students_seasons: 'Season(s)',
    students_family: 'Family',
    students_notes: 'Notes',
    students_parentSection: 'Parent Information',
    students_guardian: 'Guardian',
    students_mobile: 'Mobile',
    students_phone: 'Phone',
    students_email: 'Email',
    students_address: 'Address',
    students_datenschutz_ok: 'Privacy Policy Accepted',
    students_datenschutz_on: 'on',
    students_datenschutz_missing: 'Privacy Policy Pending',
    students_kurswechselHistory: 'Course Change History',
    students_noKurswechsel: 'No course change history',
    students_siblings_count: 'siblings linked',
    students_siblings_link: 'Link Sibling',
    students_siblings_none: 'No siblings linked',
    students_siblings_select: 'Select student',
    students_siblings_already: '✓ = already linked',
    students_siblings_unlink: 'Unlink',
    students_exitModal_title: 'Deactivate Student',
    students_exitDate_label: 'Exit Date',
    students_exitReason: 'Reason',
    students_exitSave: 'Save Exit',
    students_exitOptional: 'Optional',
    kurswechsel_title: 'Course Change',
    kurswechsel_current: 'Current',
    kurswechsel_date: 'Change Date',
    kurswechsel_newGroup: 'New Group',
    kurswechsel_newClass: 'New Class',
    kurswechsel_newSlot: 'New Course Time',
    kurswechsel_fee: 'New Monthly Fee (€)',
    kurswechsel_reason: 'Reason (optional)',
    kurswechsel_reasonPlaceholder: 'e.g. Schedule changed',
    kurswechsel_save: 'Save Change',
    kurswechsel_required: 'Date, Group and Class are required',
    kurswechsel_thDate: 'Date',
    kurswechsel_thFrom: 'From Group',
    kurswechsel_thFromClass: 'From Class',
    kurswechsel_thTo: 'To Group',
    kurswechsel_thToClass: 'To Class',
    kurswechsel_thSlot: 'Course Time',
    kurswechsel_thReason: 'Reason',
    jahreswechsel_title: 'Year Transition — Class Promotion',
    jahreswechsel_info: 'All students in a class are moved to a new class. The change is recorded in the course change history.',
    jahreswechsel_from: 'Source Class (From)',
    jahreswechsel_to: 'Target Class (To)',
    jahreswechsel_date: 'Change Date',
    jahreswechsel_note: 'Note (optional)',
    jahreswechsel_notePlaceholder: 'e.g. Year transition 2025/2026',
    jahreswechsel_save: 'Execute Class Transition',
    jahreswechsel_saving: 'Moving…',
    jahreswechsel_required: 'Fill in required fields',
    jahreswechsel_same: 'Source and target class must be different',
    jahreswechsel_confirm: 'Move all active students from "{from}" to "{to}"?',
    jahreswechsel_success: 'students moved',
    students_linkModal_title: 'Link Sibling',
    students_linkModal_of: 'Siblings of',

    waiting_title: 'Waiting List',
    waiting_add: 'Add to Waiting List',
    waiting_edit: 'Edit Entry',
    waiting_activate: 'Activate',
    waiting_noFound: 'No entries',
    waiting_count: 'Entries',
    waiting_nr: 'No.',
    waiting_regDate: 'Reg. Date',
    waiting_name: 'Name',
    waiting_dob: 'Birth',
    waiting_slot: 'Course Time',
    waiting_parent: 'Parent',
    waiting_phone: 'Phone',
    waiting_filterSlot: 'All Course Times',

    families_title: 'Families',
    families_add: 'Add Family',
    families_edit: 'Edit Family',
    families_count: 'Families',
    families_nr: 'No.',
    families_name: 'Family Name',
    families_parent: 'Parent',
    families_contact: 'Contact',
    families_children: 'Children',
    families_member: 'Member',
    families_noFound: 'No families found',
    families_deleteConfirm: 'Delete family and all links?',
    families_linkFamily: 'Link to Existing Family',
    families_newFamily: '— New Family / No Link —',
    families_autofilled: 'Fields were automatically filled.',
    families_siblings: 'Siblings',
    families_noSiblings: 'No other children in this family.',
    families_parent2: '2nd Guardian (optional)',
    families_parentFirst: 'Guardian First Name',
    families_parentLast: 'Guardian Last Name',
    families_parent2First: '2nd Guardian First Name',
    families_parent2Last: '2nd Guardian Last Name',
    families_parent2Rel: '2nd Guardian Relation',
    families_parent2Mobile: '2nd Guardian Mobile',
    families_parent2Email: '2nd Guardian Email',

    payments_title: 'Payment Overview',
    payments_rollover: 'Season Rollover',
    payments_rolloverSelected: 'selected',
    payments_totalPaid: 'Total Paid',
    payments_openMonth: 'Outstanding (current month)',
    payments_openYear: 'Outstanding (full year)',
    payments_filterOverdue: 'Overdue',
    payments_filterPaid: 'Settled',
    payments_nr: 'No.',
    payments_name: 'Name',
    payments_group: 'Grp.',
    payments_reg: 'Reg.',
    payments_paid: 'Paid',
    payments_open: 'Open',
    payments_openYearCol: 'Open (Year)',
    payments_carried: 'Carried',
    payments_payMode: '⏱',
    payments_yearly: 'Yearly',
    payments_monthly: 'Monthly',
    payments_rolloverTitle: 'Season Rollover',
    payments_rolloverInfo: 'Choose for each student whether outstanding amounts should be carried over to the new season.',
    payments_fromSeason: 'From Season',
    payments_toSeason: 'To Season',
    payments_previewBtn: 'Load Preview',
    payments_openAmount: 'Outstanding Amount',
    payments_transfer: 'Carry over? (€)',
    payments_totalCarry: 'Total Carry',
    payments_confirmRollover: 'Confirm Rollover',
    payments_doingRollover: 'Processing…',
    payments_rolloverDone: 'Season rollover to "{season}" completed',
    payments_noTargetSeason: '— no further seasons —',
    payments_selectSeason: 'Please select a target season',
    payments_editTitle: 'Edit Payment',
    payments_monthlyPay: 'Monthly Payments',
    payments_paySettings: 'Payment Settings',
    payments_payModeLabel: 'Payment Mode',
    payments_monthlyFee: 'Monthly Fee (€)',
    payments_monthlyBase: 'Monthly Base (€)',
    payments_yearlyDisc: 'Annual Discount (€)',
    payments_regFee: 'Registration Fee (€)',
    payments_regFeePaid: 'Registration Fee Paid',
    payments_regFeePaidYes: 'Paid',
    payments_regFeePaidNo: 'Not paid',
    payments_annualDisc: 'Annual Discount (€)',
    payments_waiver: 'Waiver (€)',
    payments_waiverReason: 'Waiver Reason',
    payments_carriedField: 'Carried Over (€)',
    payments_butRef: 'BuT Reference',
    payments_noteLabel: 'Note',
    payments_notePlaceholder: 'Payment note…',
    payments_expected: 'Expected',
    payments_paidLabel: 'Paid',
    payments_openLabel: 'Open',
    payments_monthly: 'Monthly',
    payments_carriedLabel: 'Carried',
    payments_carriedFrom: 'from',
    payments_carriedPrev: 'from previous year',
    payments_carriedNote: 'already included in "Open"',
    payments_stand: 'Status',
    payments_editInTable: 'Edit individual months in the table',
    payments_regFeeStatus: 'Registration fee payment status',
    payments_selectGroup: '— Select Group —',
    payments_selectClass: '— Select Class —',
    payments_selectSlot: '— Select Time —',

    reports_title: 'Reports',
    reports_tabStats: '📊 Statistics',
    reports_tabBal: 'Balances',
    reports_tabMonthly: 'Monthly Revenue',
    reports_tabRoster: 'Class Roster',
    reports_tabBut: 'BuT Overview',
    reports_totalStudents: 'Total Students',
    reports_active: 'Active',
    reports_inactive: 'Inactive',
    reports_boys: 'Boys (active)',
    reports_girls: 'Girls (active)',
    reports_byGroup: 'Students by Group',
    reports_ageGroups: 'Age Groups (active students)',
    reports_ageCol: 'Age',
    reports_boysCol: 'Boys',
    reports_girlsCol: 'Girls',
    reports_totalCol: 'Tot.',
    reports_balNr: 'No.',
    reports_balName: 'Name',
    reports_balGroup: 'Group',
    reports_balPaid: 'Paid',
    reports_balOpen: 'Open',
    reports_monthNr: 'No.',
    reports_monthName: 'Name',
    reports_monthTotal: 'Total',
    reports_rosterNr: '#',
    reports_rosterName: 'Name',
    reports_rosterDob: 'Birth',
    reports_rosterGroup: 'Group',
    reports_rosterSlot: 'Course Time',
    reports_rosterParent: 'Parent',
    reports_rosterPhone: 'Phone',
    reports_allGroups: 'All Groups',
    reports_print: '🖨 Print',
    reports_noStudents: 'No students found',
    reports_butNr: 'No.',
    reports_butChild: 'Child',
    reports_butStudent: 'Student',
    reports_butGroup: 'Group',
    reports_butType: 'Type',
    reports_butExpiry: 'Valid Until',
    reports_butExpired: 'BuT entries have expired',
    reports_butExpiring: 'BuT entries expiring within 30 days',
    reports_noBut: 'No BuT entries',
    reports_balViewStudent: 'Student',
    reports_balViewFamily: 'Family',
    reports_balFamChildren: 'Children',
    reports_balFamNoFamily: 'No Family',

    but_title: 'BuT Management',
    but_tabEntries: 'BuT Entries',
    but_tabPayments: 'Payments',
    but_add: 'Add BuT Entry',
    but_edit: 'Edit BuT Entry',
    but_addPayment: 'Add Payment',
    but_deleteConfirm: 'Delete BuT entry?',
    but_nr: 'No.',
    but_child: 'Child',
    but_student: 'Student',
    but_type: 'Type',
    but_validFrom: 'From',
    but_validTo: 'Until',
    but_amount: 'Amount/Month',
    but_status: 'Status',
    but_noEntries: 'No BuT entries',
    but_letter: 'Letter',
    but_expiredAlert: 'BuT entries have expired',
    but_expiringAlert: 'BuT entries expiring within 30 days',

    customizing_title: 'Customizing',
    customizing_tabGruppe: 'Groups',
    customizing_tabKlasse: 'Classes',
    customizing_tabSlot: 'Course Times',
    customizing_tabBildungsgrad: 'Education Level',
    customizing_tabSeasons: 'Season/Year',
    customizing_tabCounters: 'Number Series',
    customizing_addGroup: 'Add Group',
    customizing_addClass: 'Add Class',
    customizing_addSlot: 'Add Course Time',
    customizing_addSeason: 'Add Season',
    customizing_activateSeason: 'Activate',
    customizing_saveCounters: 'Save Number Series',
    customizing_seasonCode: 'Code',
    customizing_seasonLabel: 'Label',
    customizing_seasonStart: 'Start',
    customizing_seasonEnd: 'End',
    customizing_activeSeason: 'Active',
    customizing_group: 'Group',
    customizing_fee: 'Monthly Fee (€)',
    customizing_order: 'Order',
    customizing_prefix: 'Prefix',
    customizing_nextNr: 'Next No.',

    users_title: 'User Management',
    users_add: 'Add User',
    users_username: 'Username',
    users_fullName: 'Full Name',
    users_role: 'Role',
    users_family: 'Family',
    users_language: 'Language',
    users_status: 'Status',
    users_password: 'Password',
    users_changePassword: 'Change Password',
    users_newPassword: 'New Password',
    users_confirmPassword: 'Confirm Password',
    users_deactivateConfirm: 'Deactivate user?',
    users_deactivated: 'Deactivated',
    users_created: 'User created',
    users_pwChanged: 'Password changed',
    users_selectFamily: '— Select Family —',
    users_lang_de: 'Deutsch',
    users_lang_tr: 'Türkçe',
    users_lang_en: 'English',
    users_pwMin: 'Password must be at least 8 characters',
    users_pwMismatch: 'Passwords do not match',

    import_title: 'Import Data',
    import_noAccess: 'No Access',
    import_downloadTemplate: 'Download Template',
    import_uploadFile: 'Upload File',
    import_confirmImport: 'Confirm Import',
    import_backupTitle: 'Backup / Restore',
    import_backupRestore: 'Restore Backup',

    login_title: 'Maktab',
    login_sub: 'Student Management System',
    login_user: 'Username',
    login_pass: 'Password',
    login_btn: 'Sign In',
    login_err: 'Invalid credentials',
    login_welcome: 'Welcome',
  },
};

export default T;
